export function dateGteIso(date: string): string {
  return `${date}T00:00:00.000Z`
}

export function dateLtIso(date: string): string {
  // End date is exclusive — add 1 UTC day so the last day is included in the range
  const d = new Date(`${date}T00:00:00.000Z`)
  d.setUTCDate(d.getUTCDate() + 1)
  return d.toISOString()
}
